import React from "react"
import { SpecialtyReqsIds } from "./loadConstants"

export const specialtyRequirementsText: any= {
  [SpecialtyReqsIds.SCALE_TICKET]: <>a <b>scale ticket</b></>,
  [SpecialtyReqsIds.PICKUP_LIGHT_SCALE]: <>a <b>light scale</b></>,
  [SpecialtyReqsIds.DELIVERY_LIGHT_SCALE]: <>a <b>light scale</b></>,
  [SpecialtyReqsIds.PICKUP_DRIVER_WORK]: <b>driver work</b>,
  [SpecialtyReqsIds.DELIVERY_DRIVER_WORK]: <b>driver work</b>,
  [SpecialtyReqsIds.PICKUP_DRIVER_COUNT]: <b>driver count</b>,
  [SpecialtyReqsIds.DELIVERY_DRIVER_COUNT]: <b>driver count</b>,
  [SpecialtyReqsIds.PROTECT_FROM_FREEZING]: <b>protection from freezing</b>,
  [SpecialtyReqsIds.TEAM_DRIVERS]: <b>team drivers</b>,
  [SpecialtyReqsIds.TANKER_ENDORSEMENT]: <b>tanker endorsement</b>,
  [SpecialtyReqsIds.PERMIT]: <>a <b>permit</b></>,
  [SpecialtyReqsIds.LIQUOR_PERMITS]: <b>liquor permits</b>,
  [SpecialtyReqsIds.DRIVER_LOAD]: <b>driver load</b>,
  [SpecialtyReqsIds.DRIVER_UNLOAD]: <b>driver unload</b>,
  [SpecialtyReqsIds.E_TRACKS]: <b>E-tracks</b>,
  [SpecialtyReqsIds.METAL_FLOORS_ONLY]: <b>metal floors only</b>
}

export const specialtyCantHave = {
  [SpecialtyReqsIds.NO_ROLL_DOORS]: <>cannot have <b>roll doors</b></>
}

export const specialtyTypesText: any = {
  [SpecialtyReqsIds.PICKUP_TWIC]: <b>TWIC</b>,
  [SpecialtyReqsIds.DELIVERY_TWIC]: <b>TWIC</b>,
  [SpecialtyReqsIds.PICKUP_BLIND]: <b>blind</b>,
  [SpecialtyReqsIds.DELIVERY_BLIND]: <b>blind</b>,
  [SpecialtyReqsIds.PICKUP_LIFTGATE]: <b>liftgate</b>,
  [SpecialtyReqsIds.DELIVERY_LIFTGATE]: <b>liftgate</b>,
  [SpecialtyReqsIds.PICKUP_PALLET_EXCHANGE]: <b>pallet exchange</b>,
  [SpecialtyReqsIds.DELIVERY_PALLET_EXCHANGE]: <b>pallet exchange</b>
}

export const allSpecialtyText = {
  ...specialtyRequirementsText,
  ...specialtyTypesText,
  ...specialtyCantHave
}

